



































































import { Component, Vue } from 'vue-property-decorator'
import SearchInput from '@/components/SearchInput/index.vue'
import Tabs from '@/components/Tabs/index.vue'
import { getLivePlanList } from '@/api/live'
import { splitArr } from '@/utils/tool'

@Component({
  name: 'Live',
  components: {
    SearchInput,
    Tabs
  }
})
export default class Live extends Vue {
  private enrolState = -99
  private page = 1
  private resultNum = 8
  private sizeAll = 0
  private keyword = '' // 搜索关键字
  private loading = false
  private defaultImg = '/images/null.png'
  private liveData: any[] = []
  private tabList: any[] = [
    {
      id: -99,
      name: '直播列表'
    },
    {
      id: 1,
      name: '我的直播'
    }
  ]

  private statusMap = {
    // 报名时间未开始
    0: {
      statusText: '待报名',
      statusColor: '#fff',
      statusBg: '#05C19E',
      btnText: '立即报名',
      btnColor: '#9AA5B5',
      btnBg: '#ECF1F8'
    },
    // 报名开始中 还未报名
    1: {
      statusText: '报名中',
      statusColor: '#fff',
      statusBg: '#00A5FE',
      btnText: '立即报名',
      btnColor: '#fff',
      btnBg: '#00A5FE'
    },
    // 报名开始中，已报名了，继续报名
    2: {
      statusText: '报名中',
      statusColor: '#fff',
      statusBg: '#00A5FE',
      btnText: '继续报名',
      btnColor: '#fff',
      btnBg: '#00A5FE'
    },
    // 报名结束了，已经报名了
    3: {
      statusText: '报名结束',
      statusColor: '#9AA5B5',
      statusBg: '#ECF1F8',
      btnText: '已报名',
      btnColor: '#9AA5B5',
      btnBg: '#ECF1F8'
    },
    // 报名结束了，还未报名
    4: {
      statusText: '报名结束',
      statusColor: '#9AA5B5',
      statusBg: '#ECF1F8',
      btnText: '未报名',
      btnColor: '#9AA5B5',
      btnBg: '#ECF1F8'
    }
  }

  created () {
    this.getLivePlanList()
  }

  // 搜索事件触发
  clickSearch (item): void {
    this.keyword = item
    this.getLivePlanList()
  }

  // tab事件
  changeTabs () {
    this.page = 1
    this.getLivePlanList()
  }

  // 获取直播
  async getLivePlanList () {
    this.loading = true
    const params = {
      enrolState: this.enrolState,
      title: this.keyword,
      page: this.page,
      resultNum: this.resultNum
    }
    const res = await getLivePlanList(params)
    this.loading = false
    this.liveData = res.results
    this.sizeAll = res.sizeAll
    this.liveData.forEach(e => {
      // 按照状态判断
      if (e.state === 0) {
        e.renderObj = this.statusMap[0]
      } else if (e.state === 1) {
        if (e.enrolState === 0) e.renderObj = this.statusMap[1]
        if (e.enrolState === 1) e.renderObj = this.statusMap[2]
      } else if (e.state === 2 || e.state === 3) {
        if (e.enrolState === 0) e.renderObj = this.statusMap[4]
        if (e.enrolState === 1) e.renderObj = this.statusMap[3]
      } else {
        e.renderObj = {}
      }
    })
  }

  get list () {
    return splitArr(this.liveData, 4)
  }

  // 去详情
  goDetail (item) {
    this.$router.push({
      path: `/liveDetail?id=${item.id}`
    })
  }

  // 立即报名
  playing (item) {
    // 灰色按钮不给点击报名
    if (item.renderObj.btnBg === '#ECF1F8') {
      return
    }
    console.log('报名!')
  }

  // 切换分页
  currentChange (item): void {
    this.page = item
    this.getLivePlanList()
  }
}
